import { IPrzelewyWebPaymentResponse } from '@model';
import { ELogLevel, LoggerType } from '@services/errorService';
import { IGeneralRequestResponse } from '@services/httpClientService';

export const mappingFunction = (
  data: IGeneralRequestResponse<IPrzelewyWebPaymentResponse>,
  logger: LoggerType,
): IPrzelewyWebPaymentResponse | null => {
  if (!data.data?.token) {
    logger({
      logLevel: ELogLevel.WARNING,
      logMessage: 'Unable to decode Przelewy Payment Oalt Initiate data',
      additionalData: [{ key: 'Przelewy Oalt Payment Response', data: data }],
    });
    return null;
  }

  return {
    ...data.data,
  };
};
